import { Button, Divider, Grid, List, ListItem, Tooltip } from "@mui/material";
import { isUndefined } from "lodash";
import {
  RESOURCES_BASEPATH,
  SCREENING_MATCH_STATUS_ICON_FOR_BUTTONS,
  SCREENING_MATCH_STATUS_TOOLTIP_TITLE,
} from "../Constants";
import {
  padding0,
  padding2,
  textColor,
  topActionButtonBaseStyle,
} from "../Styles";
import { useRedirect } from "ra-core";

export const ScreeningReportGrid = ({ record }) => {
  return (
    <Grid container flexGrow={1}>
      <Grid item xs={12}>
        <List sx={padding0.y}>
          {!isUndefined(record?.pepReportId) && (
            <ScreeningReportItem
              reportId={record.pepReportId}
              title="Politically Exposed Person"
              id={record.id}
              matchStatus={record.pepReportMatch}
            />
          )}
          {!isUndefined(record?.watchlistReportId) && (
            <ScreeningReportItem
              reportId={record.watchlistReportId}
              title="Watchlist Report"
              id={record.id}
              matchStatus={record.watchlistReportMatch}
            />
          )}
          {!isUndefined(record?.adverseMediaReportId) && (
            <ScreeningReportItem
              reportId={record.adverseMediaReportId}
              title="Adverse Media Report"
              id={record.id}
              matchStatus={record.adverseMediaReportMatch}
            />
          )}
        </List>
      </Grid>
    </Grid>
  );
};

export const ScreeningReportItem = ({ reportId, title, id, matchStatus }) => {
  const redirect = useRedirect();
  return (
    <>
      <ListItem sx={padding2.y}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={6} sx={textColor.gray}>
            {title}
          </Grid>
          <Grid item xs={12} md={6}>
            <Grid container alignItems="center">
              <Button
                id={`screening-report-dialog-view-report-button-${reportId}`}
                size="small"
                onClick={() => redirect(`${RESOURCES_BASEPATH.IDENTITY_VERIFICATION}/${id}/screening-report/${reportId}`)}
                sx={{
                  ...topActionButtonBaseStyle("white", "#383848", "#181822"),
                  margin: "0px",
                  fontSize: "revert",
                }}
              >
                View Report
              </Button>
              <Tooltip
                title={SCREENING_MATCH_STATUS_TOOLTIP_TITLE[matchStatus]}
                placement="top"
              >
                {SCREENING_MATCH_STATUS_ICON_FOR_BUTTONS[matchStatus]}
              </Tooltip>
            </Grid>
          </Grid>
        </Grid>
      </ListItem>
      <Divider light />
    </>
  );
};
